import * as React from "react";
import { useUnit } from "effector-react";
import { nanoid } from "nanoid";
import { initVKIDAuth } from "domains/profile";
import { useNavigate } from "react-router";
import { BASE_URL } from "const";

const REDIRECT_URI = "https://xn--90aamkcop0a.xn--p1ai";

type UseVKIDAuthParams = {
    containerId?: string;
    stage?: string
};

export const useVKIDAuth = ({
    containerId = "VkIdSdkOAuthList",
    stage = ''
}: UseVKIDAuthParams) => {
    const initVKIDAuthFx = useUnit(initVKIDAuth);
    const navigate = useNavigate();

    const codeVerifierRef = React.useRef("");
    const stateRef = React.useRef("");

    React.useEffect(() => {
        //@ts-expect-error
        const VKID = window.VKIDSDK;

        if (!VKID) {
            console.error("VKID SDK not found on window");
            return;
        }

        const oauthList = new VKID.OAuthList();

        const codeVerifier = nanoid(128);
        const state = nanoid(40);

        codeVerifierRef.current = codeVerifier;
        stateRef.current = state;

        VKID.Config.init({
            app: 54598198,
            redirectUrl: REDIRECT_URI,
            source: VKID.ConfigSource.LOWCODE,
            state: state,
            codeVerifier: codeVerifier,
            scope: "email phone",
            responseMode: VKID.ConfigResponseMode.Callback,
            mode: VKID.ConfigAuthMode.InNewWindow,

        });

        const handleError = (err: unknown) => {
            console.error(err);
        };

        const handleLoginSuccess = async (payload: any) => {

            try {
                await initVKIDAuthFx({
                    platform: "WEB",
                    code: payload.code,
                    state: stateRef.current,
                    codeVerifier: codeVerifierRef.current,
                    deviceId: payload.device_id,
                    redirectUri: REDIRECT_URI,
                });
                navigate('/')
            } catch (error) {
                console.error(error);
            }
        };

        const container = document.getElementById(containerId);

        if (container) {
            oauthList
                .render({
                    container,
                    oauthList: [VKID.OAuthName.VK],
                    scheme: VKID.Scheme.LIGHT,
                    lang: VKID.Languages.RUS,
                    styles: {
                        height: 44,
                        borderRadius: 8,
                    },
                })
                .on(VKID.WidgetEvents.ERROR, handleError);
        }

        oauthList.on(
            VKID.OAuthListInternalEvents.LOGIN_SUCCESS,
            handleLoginSuccess,
        );

        return () => {
            oauthList.off(
                VKID.OAuthListInternalEvents.LOGIN_SUCCESS,
                handleLoginSuccess,
            );
        };
    }, [containerId, initVKIDAuthFx, stage]);
};